import React, { useEffect, useState } from "react";
import {
  createShippingRate,
  deleteShippingRate,
  getPurchases,
  getShippingRates,
  updatePurchaseStatus,
  updateShippingRate,
} from "../../services/purchases";
import cartIcon from "../../assets/icons/cart.webp";
import { IoIosEye } from "react-icons/io";
import CommonTitle from "../../components/CommonTitle";
import LoadingPage from "../../components/LoadingPage";
import ModalStructure from "../../components/ModalStructure";
import { IS_LOCAL_ENV } from "../../App";
import Notification from "../../components/ui-elements/Notification";
import PurchaseCard from "../../components/purchases/PurchaseCard";
import Pagination from "../../components/Pagination";
import CustomInput from "../../components/CustomInput";
import { MdOutlineDeleteOutline } from "react-icons/md";
import Filters from "../../components/Filters";
import FilterItem from "../../components/FilterItem";

const ClientPurchases = () => {
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const [shippingRates, setShippingRates] = useState([]);

  //=========pagination props====================
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  //==========sort prop==========================
  const [sortedProp, setSortedProp] = useState(null);

  //==================filtros===========================
  const [loadingFilter, setLoadingFilter] = useState(false);

  const [selectPropsList, setSelectPropsList] = useState([
    {
      isInput: true,
      title: "ID transacción",
      value: "",
      onChange: (e) => updateSelectProp(0, e),
      placeholder: "Buscar ID",
      inputType: "text",
      formatedValue: (val) => val,
      dbField: "transactionId",
    },
    {
      isInput: true,
      title: "Nro de orden",
      value: "",
      onChange: (e) => updateSelectProp(1, e),
      placeholder: "Buscar nro",
      inputType: "text",
      formatedValue: (val) => val,
      dbField: "orderNumber",
    },
    {
      options: [
        { value: "pending", text: "Pendiente" },
        { value: "canceled", text: "Cancelado" },
        { value: "delivered", text: "Entregado" },
      ],
      title: "Estado",
      value: "",
      setValue: (e) => updateSelectProp(2, e),
      formatedValue: (val) => val,
      dbField: "status",
    },
    {
      isInput: true,
      title: "Fecha de compra(desde)",
      value: "",
      onChange: (e) => updateSelectProp(3, e),
      inputType: "date",
      formatedValue: (val) => new Date(val).toISOString().split("T")[0],
      dbField: "createdAt",
    },
    {
      isInput: true,
      title: "Fecha de entrega(desde)",
      value: "",
      onChange: (e) => updateSelectProp(4, e),
      inputType: "date",
      formatedValue: (val) => new Date(val).toISOString().split("T")[0],
      dbField: "shippingDate",
    },
  ]);

  const updateSelectProp = (i, e) => {
    setSelectPropsList((prev) => {
      let temp = [...prev];
      temp[i].value = e.target.value;
      return temp;
    });
  };

  const [filterQueryObject, setFilterQueryObject] = useState({});

  const applyFilters = () => {
    let temp = [];

    temp = selectPropsList
      .filter((filter) => filter.value != "")
      .map((filter) => ({
        [filter.dbField]: {
          [filter.dbField == "createdAt" || filter.dbField == "shippingDate"
            ? "greaterThanEqual"
            : "equals"]: filter.formatedValue(filter.value),
        },
      }));

    let dt = selectPropsList[3].value;
    if (dt != "") {
      const baseDate = new Date(dt);
      baseDate.setUTCHours(0, 0, 0, 0);
      const utcDate = new Date(baseDate.getTime() + 5 * 60 * 60 * 1000);
      temp.push({
        createdAt: {
          greater_than_equal: utcDate.toISOString(),
        },
      });
    }

    let dt2 = selectPropsList[4].value;
    if (dt2 != "") {
      const baseDate = new Date(dt2);
      baseDate.setUTCHours(0, 0, 0, 0);
      const utcDate = new Date(baseDate.getTime() + 5 * 60 * 60 * 1000);
      temp.push({
        shippingDate: {
          greater_than_equal: utcDate.toISOString(),
        },
      });
    }

    const filterQuery =
      temp.length > 1 ? { and: temp } : temp.length === 1 ? temp[0] : {};

    setFilterQueryObject(filterQuery);
  };

  //====================================================================

  useEffect(() => {
    const fetchShippingRates = async () => {
      try {
        const { docs, totalPages } = await getShippingRates();
        setShippingRates(docs);
        setTotalPages(totalPages);
      } catch (err) {
        Notification({
          title: "Error",
          text: "Error al cargar las tarifas",
          type: "Error",
        });

        IS_LOCAL_ENV && console.error(err);
      }
    };

    fetchShippingRates();
  }, []);

  useEffect(() => {
    setLoading(true);
    const fetchPurchases = async () => {
      try {
        const { docs, totalPages } = await getPurchases(
          currentPage,
          sortedProp,
          filterQueryObject
        );
        setPurchases(docs);
        setTotalPages(totalPages);
      } catch (err) {
        Notification({
          title: "Error",
          text: "Error al cargar las compras",
          type: "Error",
        });

        IS_LOCAL_ENV && console.error(err);
      } finally {
        setLoading(false);
        setLoadingFilter(false);
      }
    };

    fetchPurchases();
  }, [currentPage, sortedProp, filterQueryObject]);

  const handleChangeRateProp = (e, idx, row) => {
    let temp = [...shippingRates];
    temp[idx][row] = e.target.value;
    setShippingRates(temp);
  };

  const handleSaveShippingRates = async () => {
    if (
      shippingRates.some(
        (rate) => !rate.zone || !rate.district || !rate.price
      ) ||
      shippingRates.length == 0
    ) {
      Notification({
        title: "Error",
        text: "Debe rellenar todos los campos",
        type: "Error",
      });
      return;
    }
    try {
      let newRts = [];
      await Promise.all(
        shippingRates.map(async (rate, i) => {
          if (rate?.id) {
            const { doc } = await updateShippingRate(rate.id, rate);
            newRts = [...newRts, doc];
          } else {
            const { doc } = await createShippingRate(rate);
            newRts = [...newRts, doc];
          }
        })
      );
      setShippingRates(newRts);

      Notification({
        title: "Operación completada",
        text: "Tarifas de envío actualizadas exitosamente",
        type: "Success",
      });
    } catch (err) {
      Notification({
        title: "Error",
        text: "Error al actualizar las tarifas",
        type: "Error",
      });

      IS_LOCAL_ENV && console.error(err);
    }
  };

  const handleDeleteRate = async (idx) => {
    try {
      if (shippingRates[idx].id) {
        await deleteShippingRate(shippingRates[idx].id);
        Notification({
          title: "Operación completada",
          text: "Tarifa eliminada exitosamente",
          type: "Success",
        });
      }
      let temp = [...shippingRates];
      temp = temp.filter((rate, i) => i !== idx);
      setShippingRates(temp);
    } catch (err) {
      Notification({
        title: "Error",
        text: "Error al eliminar la tarifa",
        type: "Error",
      });

      IS_LOCAL_ENV && console.error(err);
    }
  };

  const handleAddRate = () => {
    if (
      Object.values(shippingRates[shippingRates.length - 1]).some(
        (value) => `${value}`.trim() === ""
      )
    ) {
      Notification({
        title: "Error",
        text: "Debe rellenar todos los campos",
        type: "Error",
      });
      return;
    }
    let temp = [...shippingRates];
    temp.push({
      zone: "",
      district: "",
      price: "",
    });
    setShippingRates(temp);
  };

  const handleChangePurchaseStatus = (newVal, id) => {
    const updt = async () => {
      try {
        await updatePurchaseStatus(id, newVal);
        Notification({
          title: "Operación completada",
          text: "Estado actualizado exitosamente",
          type: "Success",
        });
      } catch (err) {
        Notification({
          title: "Error",
          text: "Error al actualizar el estado",
          type: "Error",
        });

        IS_LOCAL_ENV && console.error(err);
      }
    };
    updt();
  };

  return (
    <div className="w-full h-full flex flex-col pb-4 overflow-y-auto">
      <CommonTitle
        title="Registro de compras"
        text="Visualiza y actualiza el estado de las compras realizadas por los clientes."
        img={cartIcon}
      >
        <button
          className={` w-fit bg-accent-green text-base m-1 rounded-full py-4 px-6 text-white hover:bg-dark-green transition-all duration-100 font-bold font-poppins `}
          onClick={() => setShowModal(true)}
        >
          <div className="flex flex-row items-center gap-1">
            <span className="text-nowrap">Tarifas de envío</span>
            <IoIosEye />
          </div>
        </button>
      </CommonTitle>

      <div className="flex flex-col items-center w-full justify-center">
        <Filters applyFilters={applyFilters}>
          {!loadingFilter &&
            selectPropsList.map((props, i) => {
              return <FilterItem props={props} key={i} />;
            })}
        </Filters>
        {loading && <LoadingPage />}
        {!loading && (
          <div className="flex flex-col max-w-[1920px] w-full items-center justify-start md:p-6 p-2 h-full gap-4  p-6  ">
            {purchases &&
              purchases.map((purchase, i) => {
                return (
                  <PurchaseCard
                    info={purchase}
                    key={i}
                    handleChangePurchaseStatus={handleChangePurchaseStatus}
                    //loadToParent={loadToParent}
                    //removeFromParent={removeFromParent}
                  />
                );
              })}
          </div>
        )}

        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
        />
      </div>

      {/**Modals */}
      {showModal && (
        <ModalStructure
          handleCloseModal={() => setShowModal(false)}
          customMaxW={"max-w-[760px]"}
        >
          <div className="flex flex-col items-center justify-center   font-poppins w-full">
            <h3 className="font-poppins font-bold text-dark-green text-wrap text-lg my-2">
              Tarifas de envío
            </h3>
            {shippingRates.map((rate, i) => {
              return (
                <div
                  className="flex flex-wrap w-full gap-1 p-1 border-[1px] items-center "
                  key={i}
                >
                  <CustomInput
                    title={"Zona"}
                    value={rate.zone}
                    onChange={(e) => handleChangeRateProp(e, i, "zone")}
                    placeholder={"ej: Lima Norte"}
                    inputType="text"
                    required={true}
                    customMaxW={"max-w-[200px]"}
                  />
                  <CustomInput
                    title={"Distrito"}
                    value={rate.district}
                    onChange={(e) => handleChangeRateProp(e, i, "district")}
                    placeholder={"ej: La Molina"}
                    inputType="text"
                    required={true}
                    customMaxW={"max-w-[300px]"}
                  />
                  <CustomInput
                    title={"Precio"}
                    value={rate.price}
                    onChange={(e) => handleChangeRateProp(e, i, "price")}
                    placeholder={"ej: 30"}
                    inputType="number"
                    required={true}
                    customMaxW={"max-w-[150px]"}
                  />
                  <button className="bg-red-500 text-base  h-fit hover:cursor-pointer rounded-full p-2 text-white hover:bg-red-600 transition-all duration-100 font-bold font-poppins">
                    <MdOutlineDeleteOutline
                      className="text-white"
                      onClick={() => handleDeleteRate(i)}
                    />
                  </button>
                </div>
              );
            })}
            <div className="flex flex-wrap w-full justify-center gap-2">
              <button
                className="bg-dark-green text-base m-4 rounded-full py-2 px-6 text-white hover:bg-accent-green transition-all duration-100 font-bold font-poppins"
                onClick={handleAddRate}
              >
                Añadir
              </button>
              <button
                className="bg-dark-green text-base m-4 rounded-full py-2 px-6 text-white hover:bg-accent-green transition-all duration-100 font-bold font-poppins"
                onClick={handleSaveShippingRates}
              >
                Guardar
              </button>
            </div>
          </div>
        </ModalStructure>
      )}
    </div>
  );
};

export default ClientPurchases;
